import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { Clock, ArrowRight, BookOpen } from "lucide-react";

export const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-14">
      <SEO
        title="Blog"
        description="Field notes on AI hiring, LLM match scoring, and the future of recruiting from the team building Axiony."
        path="/blog"
      />
      <div className="mono-label flex items-center gap-1.5">
        <BookOpen className="w-3 h-3 text-[#06B6D4]" /> axiony blog
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight mt-3">
        Field notes on hiring in the age of LLMs.
      </h1>
      <p className="text-slate-400 mt-3 max-w-2xl">
        Short essays from the Axiony team on how AI is changing candidate matching,
        recruiter workflow, and the shape of hiring itself.
      </p>

      {loading ? (
        <div className="mt-12 text-slate-500 text-sm">Loading posts…</div>
      ) : posts.length === 0 ? (
        <div className="mt-12 text-slate-500 text-sm">No posts yet.</div>
      ) : (
        <div className="mt-12 grid md:grid-cols-2 gap-4" data-testid="blog-list">
          {posts.map((p, i) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-post-${i}`}
              className="group border border-white/10 bg-[#111827] rounded-xl p-6 hover:border-white/20 hover:-translate-y-0.5 transition-transform"
            >
              <div className="mono-label text-slate-500">
                {new Date(p.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
              </div>
              <h3 className="font-display text-xl font-medium mt-3 group-hover:text-[#06B6D4] transition-colors">
                {p.title}
              </h3>
              <p className="text-slate-400 text-sm mt-3 leading-relaxed">{p.excerpt}</p>
              <div className="flex items-center justify-between mt-5">
                <div className="flex items-center gap-3 text-[11px] text-slate-500 font-mono uppercase">
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {p.reading_minutes} min read
                  </span>
                  {p.tags?.[0] && (
                    <span className="px-1.5 py-0.5 rounded border border-white/10">
                      {p.tags[0]}
                    </span>
                  )}
                </div>
                <ArrowRight className="w-4 h-4 text-slate-500 group-hover:text-[#06B6D4] group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
